// extracted by mini-css-extract-plugin
export default {"smallLoading":"styles_smallLoading__CnqhP","viewStatementLoading":"styles_viewStatementLoading__peARQ","shimmer":"styles_shimmer__0syrf","fullView":"styles_fullView__VVMFN"};